import React, { useState, useEffect } from 'react';
 
 const AddToHomeScreenPrompt = () => {
   const [deferredPrompt, setDeferredPrompt] = useState(null);
   const [isVisible, setIsVisible] = useState(false);
 
   useEffect(() => {
     const handleBeforeInstallPrompt = (event) => {
       event.preventDefault();
       setDeferredPrompt(event);
       setIsVisible(true);
     };
 
     window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
 
     return () => {
       window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
     };
   }, []);
 
   const handleInstall = () => {
     if (deferredPrompt) {
       deferredPrompt.prompt();
 
       deferredPrompt.userChoice.then((choiceResult) => {
         if (choiceResult.outcome === 'accepted') {
           console.log('User accepted the install prompt');
         } else {
           console.log('User dismissed the install prompt');
         }
 
         setDeferredPrompt(null);
         setIsVisible(false);
       });
     }
   };
 
   const handleClose = () => {
     setIsVisible(false);
   };
 
   return (
     isVisible && (
       <div className="add-to-home-screen-prompt">
         <p>Add this app to your home screen for a better experience!</p>
         <button onClick={handleInstall}>Add to Home Screen</button>
         <button onClick={handleClose}>Close</button>
       </div>
     )
   );
 };
 
 export default AddToHomeScreenPrompt;